import React from 'react';
import PropTypes from 'prop-types';
import SVGIcon from 'components/SVGIcon';
import './index.scss';

/*
 * Type definitions
 */
const propTypes = {
    callback: PropTypes.func.isRequired,
    icon: PropTypes.func.isRequired,
};

function SquareButton({ callback, icon }) {
    const Icon = icon;

    return (
        <button
            type="button"
            className="square-button"
            onClick={callback}
        >
            <SVGIcon icon={Icon} />
        </button>
    );
}

SquareButton.propTypes = propTypes;

export default SquareButton;
